/*
 * Get Branches GraphQL specification
 * @module src/graphql/getBranches
 */
/* eslint-disable import/prefer-default-export */
import gql from 'graphql-tag';

export const GET_DEFAULT_SOURCE_LOCATION_MAPPING = gql`
  query GetDefaultSourceLocationMapping(
    $businessUnit: String
    $orderType: String
    $sourceLocation: String
  ) {
    getDefaultSourceLocationMapping(
      businessUnit: $businessUnit
      orderType: $orderType
      sourceLocation: $sourceLocation
    ) {
      id
      businessUnit
      orderType
      sourceLocation
      createdAt
      updatedAt
      updatedBy
    }
  }
`;